export default __webpack_public_path__ + "static/media/limb_small@2x.90b1cce1.webp";